import { EditIcon } from '@synoptic/ui-kit/icons/react/edit.tsx';
import { GroupIcon } from '@synoptic/ui-kit/icons/react/group.tsx';
import { LockIcon } from '@synoptic/ui-kit/icons/react/lock.tsx';
import { PauseIcon } from '@synoptic/ui-kit/icons/react/pause.tsx';
import { TrashIcon } from '@synoptic/ui-kit/icons/react/trash.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.tsx';
import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';
import { StreamState, StreamType } from '@/__generated__/graphql.ts';
import {
  publishedStreamTagIcon,
  streamStateTag,
} from '@/components/streams/stream-tag/stream-state-tag.css.ts';
import { StreamTag } from '@/components/streams/stream-tag/stream-tag.tsx';

export const StreamStateTag: FC<{
  state?: StreamState;
  type: StreamType;
  className?: string;
}> = ({ state, type, className }) => {
  let icon: ReactNode;
  let label: string | null = null;
  let tip: string | null = null;

  switch (state) {
    case StreamState.Draft:
      icon = <EditIcon />;
      label = 'Draft';
      tip = 'Add at least one post before you can publish this stream.';
      break;
    case StreamState.Active:
      icon =
        type === StreamType.Public ? (
          <GroupIcon className={publishedStreamTagIcon} />
        ) : (
          <LockIcon className={publishedStreamTagIcon} />
        );
      label =
        type === StreamType.Public ? 'Public (active)' : 'Private (active)';
      tip = 'Active stream indicates that an author posts regularly.';
      break;
    case StreamState.Inactive:
      icon =
        type === StreamType.Public ? (
          <GroupIcon className={publishedStreamTagIcon} />
        ) : (
          <LockIcon className={publishedStreamTagIcon} />
        );
      label =
        type === StreamType.Public ? 'Public (inactive)' : 'Private (inactive)';
      tip = `Inactive stream indicates that an author doesn't post often.`;
      break;
    case StreamState.OnHold:
      icon = <PauseIcon />;
      label = 'On hold';
      break;
    case StreamState.Deleted:
      icon = <TrashIcon />;
      label = 'Deleted';
      break;
    case undefined:
      icon =
        type === StreamType.Public ? (
          <GroupIcon className={publishedStreamTagIcon} />
        ) : (
          <LockIcon className={publishedStreamTagIcon} />
        );
      label = type === StreamType.Public ? 'Public' : 'Private';
      break;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <StreamTag
          icon={icon}
          className={clsx(
            streamStateTag[state ?? StreamState.Inactive],
            className,
          )}
        >
          {label}
        </StreamTag>
      </TooltipTrigger>
      {tip ? <TooltipContent description={tip} /> : null}
    </Tooltip>
  );
};
